/**
 * @generated SignedSource<<08763e2dc1ab8969e725b31542721324>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type SchoolExamSourceHistoryTypeEnum = "publish" | "scrap" | "upload" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource$data = {
  readonly histories: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly type: SchoolExamSourceHistoryTypeEnum;
        readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceHistoryDialog_SchoolExamSourceHistory" | "SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource";
};
export type SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource$key = {
  readonly " $data"?: SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource$data;
  readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "histories"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": {
        "created": "DESC"
      },
      "kind": "LocalArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./SchoolExamSourceSchoolExamSourceHistoryPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource",
  "selections": [
    {
      "alias": "histories",
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "concreteType": "SchoolExamSourceHistoryConnection",
      "kind": "LinkedField",
      "name": "__SchoolExamSourceSchoolExamSourceHistoryPaginator_schoolExamSource_histories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SchoolExamSourceHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SchoolExamSourceHistory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SchoolExamSourceHistoryDialog_SchoolExamSourceHistory"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SchoolExamSourceHistoryTimelineItem_schoolExamSourceHistory"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "SchoolExamSource",
  "abstractKey": null
};
})();

(node as any).hash = "7daacbeb661dc9d84e110ed3eb00387d";

export default node;
